import { z } from 'zod';

/**
 * Filter state lives in the URL, not in React state.
 *
 * That makes a filtered view shareable ("here's the bug list"), makes Back and
 * Forward work, survives a reload, and — most importantly — keeps one source of
 * truth. Filters held in both component state and the URL is a bug factory.
 */
export const BoardSearch = z.object({
  /** Label ids to filter by. */
  labels: z.array(z.string()).optional(),
  /** A group id; only cards in that group are shown. */
  group: z.string().optional(),
  /** A user id, or 'me'. */
  assignee: z.string().optional(),
  /** Free-text search across title and summary. */
  q: z.string().optional(),
  /** Whether a card must carry every selected label or just one of them. */
  match: z.enum(['any', 'all']).default('any'),
  /** The expanded card, so the big view is deep-linkable and Back closes it. */
  card: z.string().optional(),
});

export type BoardSearchParams = z.infer<typeof BoardSearch>;

export function hasActiveFilters(search: BoardSearchParams): boolean {
  return Boolean(
    (search.labels && search.labels.length > 0) ||
      search.assignee ||
      search.group ||
      (search.q && search.q.trim() !== ''),
  );
}
